var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/brand-urls.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["registrySlug"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_registrySlug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("registrySlug", l_registrySlug);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_2 = "";t_2 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 8, colno = 101, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "registry/" + "" + l_registrySlug)), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("registryUrl");
context.setVariable("registryUrl", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/brand-urls.j2"] , dependencies)